// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3P0fX","colCheckbox":"styles_colCheckbox__1OywN"};